module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1bb",
    attrs: {
      "id": "d7e228031"
    }
  }, [_c('span', [_vm._v("celery")])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e228531"
    }
  }, [_c('span', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PIUM GRAVEOLENS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e229031"
    }
  }, [_c('span', [_vm._v("Leaf celery, available from Reimers Seeds and a few other specialty catalogs, is surprisingly hardy and much easier to grow than regular celery. With a little mulching, it will survive all but the fiercest Northwest winters and produce new growth in early spring. The flavor is much stronger than that of commercial celery. Too much can overpower your pot roast, and munching it raw is out of the question. Cut the amount in half if you are using it in place of regular celery.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1b",
    attrs: {
      "id": "d7e231831"
    }
  }, [_c('span', {
    attrs: {
      "id": "d14e506"
    }
  }, [_vm._v("chestnuts")])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e232431"
    }
  }, [_c('span', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ASTENEA SPP.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e233431"
    }
  }, [_c('span', [_vm._v("North American chestnut production is making a modest comeback after the blight that devastated American trees in the early twentieth century. Despite their rich, mealy taste, chestnuts are much lower in fat than any other commercial nut. This is good news both for nutrition and versatility, as dried chestnuts can be ground into a baking flour that is much more versatile than oilier ground nut mixtures. Also unlike other nuts, chestnuts are rarely eaten raw. Roasting on an open fire is far from the only option, though. Fresh or reconstituted nuts combine beautifully in risottos, stews, soups, and purées. Chestnuts are challenging to grow—being fussy about soil, shade, and temperature. We tried them in Sumas, where walnuts, hazelnuts and fruit trees thrived, and they died within a couple of years. I’m guessing our rich, heavy loam was too wet for them. They are also tricky to store, as they are much more perishable than other nuts. Their high water content makes them prone to mold, and their thin shells mean than that fresh ones will dry unevenly and unsatisfactorily if not stored properly. I’ve had bad experiences getting them at the grocery store, and I recommend ordering straight from the farm if possible. The Chestnut Growers of America have a directory for commercial growers in the US and Canada, and many do mail order. For example, "), _c('a', {
    attrs: {
      "href": "http://Chestnutsonline.com",
      "target": "_blank"
    }
  }, [_vm._v("Chestnutsonline.com")]), _vm._v(" sells fresh and dried nuts, flour, and gluten-free baking mixes from their farm in Ridgefield, WA, on the Oregon border north of Portland. They hold farm tours during National Chestnut Week (who knew?) in October. If you have a windfall supply of fresh nuts, they can be refrigerated in a plastic bag for a couple of weeks or peeled and frozen. Dried chestnuts do keep well.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e242832"
    }
  }, [_c('span', [_vm._v("Foragers take note: the lovely Northwest native horse chestnut tree is a different family and produces nuts that look similar but are only marginally edible and are toxic when eaten raw. They are not a useful substitute. If you have the space for at least two large trees (chestnuts need a pollinator), and the right conditions, you can buy stock and get detailed information from Washington Chestnut Company in Everson, WA: "), _c('a', {
    attrs: {
      "href": "http://washingtonchestnut.com",
      "target": "_blank"
    }
  }, [_vm._v("washingtonchestnut.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1b",
    attrs: {
      "id": "d7e245332"
    }
  }, [_c('span', [_vm._v("chicory")])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e245832"
    }
  }, [_c('span', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ICHORIUM ENDIVA VAR. CRISPA")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', [_c('img', {
    staticClass: "imgpub",
    attrs: {
      "alt": "2010-11-08T18-23-50-706_9781550924589_0032_001",
      "id": "d14e524",
      "src": "Images/2010-11-08T18-23-50-706_9781550924589_0032_001.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e246532"
    }
  }, [_c('span', [_vm._v("The nomenclature for chicory and its relatives is confusing, to say the least. Common names have undergone strange transmutations as they traveled from European kitchens, so that the Brussels (or Witloof) chicory they serve in Brussels is better known here as Belgian endive, and the French "), _c('i', [_vm._v("chicorée frisée")]), _vm._v(" is sold in the US as curly endive. The glamorous red radicchios are also chicories (or endives), as is escarole. Heirloom American recipes calling for “succory” also mean chicory. Check your recipe carefully for clues before you harvest or shop.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e250232"
    }
  }, [_c('span', [_vm._v("For purposes of this book, chicory is a curly- or toothy-leaved, loose-headed plant with a characteristic bitter tang. It is highly regarded as a salad green, and I think it’s even better cooked. The garden plants are robust and hardier than lettuce, although constant rain discourages them. If you give them some shelter from the rain, they will thrive and sweeten through the first frosts of winter, resulting in better taste than you can buy. They keep well in a plastic bag in the refrigerator, with the added benefit that the bitterness moderates with time. The central leaves are paler and milder than the outer ones, allowing the cook to employ variations on the basic taste theme. (See also "), _c('a', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c17_r1#d7e278536",
      "id": "d14e533"
    }
  }, [_vm._v("endive")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c17_r1#d7e285436",
      "id": "d14e536"
    }
  }, [_vm._v("escarole")]), _vm._v(", and "), _c('span', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c25_r1#d7e475153",
      "id": "d14e539",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("radicchio")]), _vm._v(".)")])]), _vm._v(" "), _c('p', {
    staticClass: "h1b",
    attrs: {
      "id": "d7e254733"
    }
  }, [_c('span', [_vm._v("collards")])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e255233"
    }
  }, [_c('span', [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("RASSICA OLERACEA VAR. ACEPHALIA")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e255733"
    }
  }, [_c('span', [_vm._v("Primitive members of the cabbage family, collards are among the most forgiving of vegetables. Cool-weather gardeners like them for their hardiness; they also hold up better in hot weather than their more refined cousins, which accounts for their starring role in Southern soul food. Even the most moribund-looking January collard may revive to produce sweet new greens in March, so don’t be too quick to put them out of their misery. Here in Bellingham, the spring growth shows up at the farmers market as soon as it opens in April.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e258933"
    }
  }, [_c('span', [_vm._v("Since collards will live through most anything, you can hardly expect them to be delicate in flavor or texture. The leaves are thick and tough, and the flavor is assertive. Unlike a lot of greens, they respond well to long cooking and are excellent reheated. However, they are gaining fans in raw foods circles as a sturdy wrap covering, filling in for tortillas or rice noodles and holding up better than lettuce. I had one recently: early spring collard leaves wrapped around pumpkinseed pâté, avocado slices, salad greens and a whole lot of olive oil. It was delicious. They are an excellent vegetable source of calcium and are also high in vitamins A and C.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e262333"
    }
  }, [_c('span', [_vm._v("When shopping for collards, look for deep green—not yellowish— leaves and firm stems. Collards are never crisp, but they should not be limp and floppy.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51486e28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Morg_9781550924589_epub_c14_r1.vue
// module id = 99
// module chunks = 0